export const hirePythonBannerContentEn = {
    shortHeading: "Hire Python Developers",
    mainHeading: "Accelerate <span>Innovation</span> with Expert Python Development",
    content: "Looking for skilled Python developers? Our experts offer advanced AI, machine learning, automation, and API solutions, helping you scale projects quickly and efficiently with reliable offshore support.",
};

export const hirePythonExpertiseEn = {
    shortHeading: "Expertise Our Python Programmers Offer",
    mainHeading: "Powering Scalable, High-Impact Digital Solutions with Python",
    description: "Bitsclan provides custom Python software development & top Python engineers for hire. Each Python developer on our team has many years of experience delivering industry-changing projects. Hire python developers in usa with complete ease & flexibility to team up or down as your project requirements evolve.",
    btnText: "Get Python Development",
    servicesData: [
        {
            title: "Python Web Development",
            description: "We specialize in Python web development, building powerful applications that simplify business processes & accelerate growth. Our expert Python & <a class='text-black' target='_blank' href='/hire-django-developer'>Django developers</a> execute complex codes & build optimized web applications to meet modern digital demands effectively.",
            icon: "/images/hire-page-icons/hire-python-icons1.svg",
        },
        {
            title: "Python Mobile App Development",
            description: "We offer expert Python <a class='text-black' target='_blank' href='/mobile-app-development-services'>mobile app development services</a>. Using advanced Python frameworks, our python app developers create secure, scalable, & high-speed applications for both android & iOS platforms. If you’re planning to create an app with Python, you’re in the right place, hire our remote Python developers to turn your idea into reality.",
            icon: "/images/hire-page-icons/hire-python-icons8.svg",
        },
        {
            title: "Python API Development",
            description: "Hire dedicated Python developers to design & develop APIs for your business goals. With our python api development expertise, we build AI solutions that simplify data sharing, improve application connectivity, & support growth with flexible, secure, & efficient performance across modern digital ecosystems.",
            icon: "/images/hire-page-icons/hire-python-icons2.svg",
        },
        {
            title: "Python Machine Learning",
            description: "We implement machine learning algorithms for predictive engines to enhance data analysis. Hire skilled Python programmers from us to create advanced ML applications. Our vetted python ai developers are experienced in building secure & scalable environments tailored for <a class='text-black' target='_blank' href='/ai-ml-development-services'>Python machine learning</a> development.",
            icon: "/images/hire-page-icons/hire-python-icons4.svg",
        },
        {
            title: "Python Based CMS Development",
            description: "Bitsclan provides reliable Python based CMS development with Django & Wagtail CMS. We design secure & customizable systems that support content creators, marketers, & businesses by simplifying content management. These CMSs enable automation, & add advanced website & blog features for long-term growth.",
            icon: "/images/hire-page-icons/hire-python-icons5.svg",
        },
        {
            title: "Integration & Data Migration in Python",
            description: "Bitsclan's full stack python developers provide Integration in Python to connect your apps with different platforms smoothly. Our data migration in Python services ensure smooth transitions or upgrades, minimizing downtime while improving efficiency & reliability for your business systems.",
            icon: "/images/hire-page-icons/hire-python-icons6.svg",
        },
        {
            title: "Python Software Development Services",
            description: "We deliver professional Python <a class='text-black' target='_blank' href='/ai-ml-development-services'>software development services</a>, creating scalable software solutions that boost automation & innovation. From web apps to AI, data science, & enterprise projects, our custom python developers also extend to optimizing Python programming software for Mac users.",
            icon: "/images/hire-page-icons/hire-python-icons7.svg",
        },
        {
            title: "Python Consulting Services",
            description: "As a top python consultancy firm in the USA, Bitsclan offers professional Python consulting services to companies of all sizes at any stage of the development lifecycle. Our skilled & experienced Python consultants help you plan strategically, develop efficiently, & continuously improve performance, ensuring your Python solutions deliver optimal performance & lasting value.",
            icon: "/images/hire-page-icons/hire-python-icons8.svg",
        },
    ],
};

export const hirePythonPerformanceEn = {
    shortHeading: "Why hire Python developers with us?",
    greenHeading: "Delivering Scalable ",
    heading: "Python Solutions that Drive Business Growth",
    description: "As an established Python development company, we are experts in <a class='text-black' target='_blank' href='/hire-django-developer'>creating scalable web applications</a>, data analysis tools, & AI solutions. Our experienced Python developers focus on delivering reliable, efficient, & customized software that helps businesses grow, adapt, & succeed in competitive markets.",
    statsData: [
        // {
        //     number: "2017",
        //     title: "Python Services Since",
        // },
        {
            number: "140+",
            title: "Python Success Stories"
        },
        {
            number: "100+",
            title: "Full Stack Python Engineers"
        },
        {
            number: "14+",
            title: "Python Solutions Industries"
        },
    ]
};

export const hirePythonCombinationsEn = {
    heading: "Harness Cutting-Edge Python Technologies for Business Growth",
    description: "Unlock the full potential of Python with the best tools & frameworks combinations to build secure, scalable, & high-performance applications. Hire expert Python developers to drive innovation & ensure seamless development.",
    combinations: [
        {
            title: "Python + Django + PostgreSQL",
            description:
                "Django, a high-level Python framework, combined with PostgreSQL ensures secure, scalable, & high-performance web applications.",
            icons: [
                {
                    icon: "python.svg",
                    altText: "Python programming framework",
                },
                {
                    icon: "django.svg",
                    altText: "Django web framework",
                },
                {
                    icon: "postgres.svg",
                    altText: "PostgreSQL database integration",
                },
            ],
        },
        {
            title: "Python + Flask + MySQL",
            description:
                "Flask, a lightweight Python web framework, paired with MySQL enables rapid development of scalable web applications.",
            icons: [
                {
                    icon: "python.svg",
                    altText: "Python programming framework",
                },
                {
                    icon: "flask.svg",
                    altText: "Flask backend framework",
                },
                {
                    icon: "mysql-whale-icon.svg",
                    altText: "MySQL database system",
                },
            ],
        },
        {
            title: "Python + FastAPI + MongoDB",
            description:
                "FastAPI provides high-speed API development with Python, while MongoDB serves as a flexible NoSQL database for modern applications.",
            icons: [
                {
                    icon: "python.svg",
                    altText: "Python programming framework",
                },
                {
                    icon: "fast-api.svg",
                    altText: "FastAPI Python framework",
                },
                {
                    icon: "mongodb.svg",
                    altText: "MongoDB NoSQL database",
                },
            ],
        },
        {
            title: "Python + React + PostgreSQL",
            description:
                "React for dynamic front-end development, Django or Flask for backend logic, & PostgreSQL for a robust relational database solution.",
            icons: [
                {
                    icon: "python.svg",
                    altText: "Python programming framework",
                },
                {
                    icon: "react.svg",
                    altText: "React frontend library",
                },
                {
                    icon: "postgres.svg",
                    altText: "PostgreSQL database integration",
                },
            ],
        },
        {
            title: "Python + TensorFlow + AWS",
            description:
                "Leverage Python with TensorFlow for AI & ML applications, backed by AWS cloud services for scalable computing & storage.",
            icons: [
                {
                    icon: "python.svg",
                    altText: "Python programming framework",
                },
                {
                    icon: "tensorflow.svg",
                    altText: "TensorFlow AI framework",
                },
                {
                    icon: "aws.svg",
                    altText: "AWS cloud services",
                },
            ],
        },
        {
            title: "Python + FastAPI + GraphQL",
            description:
                "FastAPI as a high-performance backend with GraphQL enables efficient API development & data fetching for modern applications.",
            icons: [
                {
                    icon: "python.svg",
                    altText: "Python programming framework",
                },
                {
                    icon: "fast-api.svg",
                    altText: "FastAPI Python framework",
                },
                {
                    icon: "graphql.svg",
                    altText: "GraphQL API integration",
                },
            ],
        },
    ]
};

export const hirePythonStepsEn = {
    heading: "Hire Python Developers in 4 Easy Steps",
    subHeading:
        "Hiring top Python developers has never been easier. Follow our simple 4-step process for a seamless experience, ensuring the right fit for your project, fast delivery, & high-quality development.",
    buttonText: "Let’s Find Your Perfect Developer",
    steps: [
        {
            title: "Choose Your Engagement Model",
            description:
                "Pick the <a class='text-black' target='_blank' href='/engagment-model'>engagement model</a> that best suits your project needs. Whether it's full-time, part-time, or hourly, we tailor the solution to your specific requirements.",
            icon: "/images/hire-page-setps-icons/icon-1.svg",
        },
        {
            title: "Screen & Select Python Developers",
            description:
                "Browse through our Python developers' profiles & select the best candidates for your project. We ensure you have access to the most qualified developers to meet your project needs.",
            icon: "/images/hire-page-setps-icons/icon-2.svg",
        },
        {
            title: "Conduct One-on-One Interview",
            description:
                "After you’ve selected your candidates, interview them directly. You can assess their skills through both theoretical & practical questions to make sure they’re the right fit for your project.",
            icon: "/images/hire-page-setps-icons/icon-3.svg",
        },
        {
            title: "Python Developers",
            description:
                "Once you’ve made your choice, the selected Python developer will join your team within 24–48 hours after final confirmation. Get started with ease & confidence, knowing your project is in good hands.",
            icon: "/images/hire-page-setps-icons/icon-4.svg",
        },
    ],
};

export const coverTheStackPythonEn = {
    whereStart: "Database",
    mainHeading: "Hire Expert Python Developers for Scalable & High-Performance Solutions",
    subHeading: "We utilize modern Python development frameworks, scalable tech stacks, & agile practices to deliver secure, reliable, & maintainable solutions, ensuring efficiency, faster deployment, & long-term value for diverse business applications",
    tabs: [
        "Database",
        "Libraries",
        "Framework",
        "DevOps",
        "Testing",
    ],
    tabItems: [
        { tab: "Framework", icon: "/images/tech-stack-icons/pytorch.svg", name: "PyTorch", altText: "PyTorch deep learning" },
        { tab: "Framework", icon: "/images/tech-stack-icons/caffe.svg", name: "Caffe", altText: "Caffe AI library" },
        { tab: "Framework", icon: "/images/tech-stack-icons/theano.svg", name: "Theano", altText: "Theano math engine" },
        { tab: "Framework", icon: "/images/tech-stack-icons/Flask.svg", name: "Flask", altText: "Flask web framework" },
        { tab: "Framework", icon: "/images/tech-stack-icons/bottle.svg", name: "Bottle", altText: "Bottle micro framework" },
        { tab: "Framework", icon: "/images/tech-stack-icons/cherrypy.svg", name: "CherryPy", altText: "CherryPy web framework" },
        { tab: "Framework", icon: "/images/tech-stack-icons/django.svg", name: "Django", altText: "Django full-stack framework" },
        { tab: "Framework", icon: "/images/tech-stack-icons/ember.svg", name: "FastAPI", altText: "FastAPI modern API" },
        { tab: "Framework", icon: "/images/tech-stack-icons/fast-api.svg", name: "FastAPI", altText: "FastAPI modern API" },
        { tab: "Framework", icon: "/images/tech-stack-icons/Pyramid.svg", name: "Pyramid", altText: "Pyramid scalable framework" },
        { tab: "Framework", icon: "/images/tech-stack-icons/tornado.svg", name: "Tornado", altText: "Tornado async tool" },
        { tab: "Framework", icon: "/images/tech-stack-icons/py-qt.svg", name: "PyQt", altText: "PyQt GUI toolkit" },
        { tab: "Framework", icon: "/images/tech-stack-icons/dash-framework.svg", name: "Dash Framework", altText: "Dash data framework" },
        { tab: "Database", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL", altText: "PostgreSQL database system" },
        { tab: "Database", icon: "/images/db3.png", name: "MongoDB", altText: "MongoDB NoSQL database" },
        { tab: "Database", icon: "/images/db5.png", name: "MySQL", altText: "MySQL relational database" },
        { tab: "Database", icon: "/images/tech-stack-icons/oracals.svg", name: "Oracle", altText: "Oracle enterprise database" },
        { tab: "Database", icon: "/images/db7.png", name: "SQLite", altText: "Lightweight SQLite database" },
        { tab: "Database", icon: "/images/tech-stack-icons/redis.svg", name: "Redis", altText: "Redis in-memory store" },
        { tab: "Database", icon: "/images/tech-stack-icons/couchdb.svg", name: "Couch DB", altText: "CouchDB document platform" },
        { tab: "Database", icon: "/images/db8.png", name: "DynamoDB", altText: "DynamoDB cloud datastore" },
        { tab: "Database", icon: "/images/tech-stack-icons/neo4j.svg", name: "Neo4j", altText: "Neo4j graph platform" },
        { tab: "Database", icon: "/images/tech-stack-icons/snowflake.svg", name: "SnowFlake", altText: "Snowflake data warehouse" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/request.svg", name: "Requests", altText: "Requests HTTP library" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/scrapy.svg", name: "Scrapy", altText: "Scrapy web scraping tool" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/pillow.svg", name: "Pillow", altText: "Pillow image processing" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/fabric.svg", name: "Fabric", altText: "Fabric automation library" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/scikit-learn.svg", name: "Scikit-learn", altText: "Scikit-learn machine learning" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/fast-api.svg", name: "FastAPI", altText: "FastAPI Python framework" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/numpy.svg", name: "NumPy", altText: "NumPy numerical library" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/pandas.svg", name: "Pandas", altText: "Pandas data analysis" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/matplotlib.svg", name: "Matplotlib", altText: "Matplotlib data visualization" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/scipy.svg", name: "SciPy", altText: "SciPy scientific computing" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/tensorflow.svg", name: "TensorFlow", altText: "TensorFlow machine learning" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/pytorch.svg", name: "PyTorch", altText: "PyTorch deep learning" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/keras.svg", name: "Keras", altText: "Keras neural network" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/django.svg", name: "Django", altText: "Django web framework" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/Streamlit.svg", name: "Stream Lit", altText: "Streamlit data apps" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/boto.svg", name: "Boto3", altText: "Boto3 AWS integration" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/Flask.svg", name: "Flask", altText: "Flask web framework" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/beautiful.svg", name: "Beautiful Soup", altText: "Beautiful Soup parsing" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/open-cv.svg", name: "OpenCV", altText: "OpenCV computer vision" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/seaborn.svg", name: "Seaborn", altText: "Seaborn data visualization" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/docker.svg", name: "Docker", altText: "Docker infrastructure tool" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/azure.svg", name: "Azure", altText: "Azure cloud platform" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/kubernetes.svg", name: "Kubernetes", altText: "Kubernetes orchestration tool" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/google-cloud.svg", name: "Google Cloud", altText: "Google Cloud services" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/serverless-functions.svg", name: "Serverless Functions", altText: "Serverless Functions tool" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/aws.svg", name: "AWS", altText: "AWS cloud platform" },
        { tab: "DevOps", icon: "/images/tech-stack-icons/digital-ocean.svg", name: "Digital Ocean", altText: "Digital Ocean cloud" },
        { tab: "Testing", icon: "/images/tech-stack-icons/postman.svg", name: "Postman", altText: "Postman testing tool" },
        { tab: "Testing", icon: "/images/tech-stack-icons/seaborn.svg", name: "Jmeter", altText: "Jmeter load tester" },
        { tab: "Testing", icon: "/images/tech-stack-icons/selenium.svg", name: "Selenium", altText: "Selenium web tester" },
        { tab: "Testing", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress", altText: "Cypress testing tool" },
        { tab: "Testing", icon: "/images/tech-stack-icons/browserstack.svg", name: "BrowserStack", altText: "BrowserStack visual tester" },
        { tab: "Testing", icon: "/images/tech-stack-icons/bugzilla.svg", name: "Bugzilla", altText: "Bugzilla testing tool" },
        { tab: "Testing", icon: "/images/tech-stack-icons/soap-icon.svg", name: "SoapUI", altText: "SoapUI testing tool" },
        { tab: "Testing", icon: "/images/tech-stack-icons/jasmine.svg", name: "Jasmine", altText: "Jasmine test framework" },
        { tab: "Testing", icon: "/images/tech-stack-icons/karma.svg", name: "Karma", altText: "Karma test runner" },
        { tab: "Testing", icon: "/images/tech-stack-icons/jenkins.svg", name: "Jenkins", altText: "Jenkins CI tool" }
    ]
};

export const hirePythonFactsDataEn = {
    heading: "Quick Facts About",
    greenHeading: "Our Python Team",
    buttonText: "book an appointment",
    facts: [
        {
            text: "<strong>40+ Python developers:</strong> Our team consists of over 40 skilled developers who specialize in Python application development.",
        },
        {
            text: "<strong>25.98 years of combined experience:</strong> With an average of nearly 26 years of experience, our team has a deep understanding of Python development.",
        },
        {
            text: "<strong>Expertise across diverse areas:</strong> We have experience in custom Python development solutions, including web development, API development, & system integrations.",
        },
        {
            text: "<strong>Advanced cloud & serverless skills:</strong> Our developers are well-versed in building secure web development with Python, following industry best practices.",
        },
        {
            text: "<strong>Experience in data-driven solutions:</strong> We work on big data, machine learning, & more to create powerful Python-based applications.",
        },
    ]
};

export const factIdeaEn = {
    heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
    content: "Have an idea but unsure how to proceed? Our Golang experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, & establish a strong foundation for success with our expert development services."
}

export const hirePythonPageContentEn = {
    hiringDetails: [
        {
            text: "Hourly Hiring",
            hours: "24 - 48",
            timeUnit: "hours",
            icon: "time.svg",
            bgColor: "#FDFDFF",
            durationLabel: "Duration", // Dynamic label
            duration: "8 Hrs/Day",     // Dynamic value
            minimumDaysLabel: "Minimum Days", // Dynamic label
            minimumDays: "30 Days",           // Dynamic value
            billingLabel: "Billing",       // Dynamic label
            billing: "Monthly",            // Dynamic value
            startWorkPhrase: "Start work in "
        },
        {
            text: "Full Time Hiring",
            hours: "48",
            timeUnit: "hours",
            icon: "full-time.svg",
            bgColor: "#FFFEFA",
            durationLabel: "Duration",
            duration: "8 Hrs/Day",
            minimumDaysLabel: "Minimum Days",
            minimumDays: "30 Days",
            billingLabel: "Billing",
            billing: "Monthly",
            startWorkPhrase: "Get started within "
        },
        {
            text: "Part Time Hiring",
            hours: "24 - 48",
            timeUnit: "hours",
            icon: "part-time.svg",
            bgColor: "#FDFFFA",
            durationLabel: "Duration",
            duration: "8 Hrs/Day",
            minimumDaysLabel: "Minimum Days",
            minimumDays: "30 Days",
            billingLabel: "Billing",
            billing: "Monthly",
            startWorkPhrase: "Launch in "
        },
    ],
    headingContent: [
        {
            "text": "Our Flexible"
        },
        {
            "text": "Engagement Models"
        },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    buttonText: "Get Started Now"
};

export const hirePythonFaqDataEn = {
    mainHeading: "Frequently Asked Questions",
    // subHeading:
    //     "Explore our Python development services for tailored web solutions, API creation, & deployment management!",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "Why hire offshore Python developers?",
            answer:
                "Hiring offshore Python developers allows businesses to save costs, access global talent, & scale efficiently. It offers flexibility, specialized expertise, & quality solutions without the high expenses of local hiring, ensuring reliable project delivery worldwide.",
        },
        {
            id: "collapseTwo",
            question: "How do I assess a Python developer's technical skills?",
            answer:
                "You can assess Python developers through technical interviews, code reviews, & practical coding tasks. Reviewing past projects or open-source contributions provides deeper insights into their abilities, problem-solving style, & coding proficiency for complex applications.",
        },
        {
            id: "collapseThree",
            question: "How Much It Will Cost to Develop a Python App?",
            answer:
                "Python app development costs depend on project complexity, features, & timelines. Hourly rates typically range from $25 to $150. For accurate budgeting, request a customized estimate based on your unique business requirements & goals.",
        },
        {
            id: "fourth",
            question: "Can your developers help me create a website with Python?",
            answer:
                "Yes, Bitsclan developers build scalable, dynamic websites using Python frameworks like Django & Flask. They focus on creating high-performing, secure, & user-friendly solutions tailored to meet modern business needs effectively & efficiently.",
        },
        {
            id: "fifth",
            question: "Can you help me in migrating my existing application into Python?",
            answer:
                "Yes. Our developers handle migration by analyzing current systems, creating a roadmap, & adapting code for Python. They test extensively, minimize downtime, & ensure applications run smoothly with improved efficiency after migration.",
        },
        {
            id: "sixth",
            question: "How does Bitsclan ensure the quality of Python developers on the platform?",
            answer:
                "Bitsclan ensures quality through a strict vetting process, technical testing, & project-based evaluations. Client feedback & regular monitoring help us maintain a reliable pool of skilled Python developers, delivering excellent results consistently across diverse projects.",
        },
    ],
};

export const mainBannerImgPython = {
    backgroundImage: `url(/images/hire-page-images/hire-python.avif)`,
    factBackgroundImage: `url(/images/hire-page-images/hire-python.avif)`
};

export const hirePageStacks = [
    {
        title: "Junior Python Developer",
        description: [
            "2 Years' experience",
            "Fresh perspectives & innovative ideas",
            "Dedicated to explore web development",
        ],
        linkText: "Connect to Hire",
        link: "#",
        borderClass: "border-1",
    },
    {
        title: "Senior Python Developer",
        description: [
            "2+ years' experience",
            "Leadership in complex projects",
            "Proven app deployment success",
        ],
        linkText: "Connect to Hire",
        link: "#",
        borderClass: "border-2",
    },
    {
        title: "Python Tech Lead",
        description: [
            "5+ years' experience",
            "Skilled with Jira, Asana, MS Teams, etc.",
            "Suitable when you Hire Web App Team",
        ],
        linkText: "Connect to Hire",
        link: "#",
        borderClass: "border-3",
    },
];

export const benefits = [
    {
        service: "Python CMS Development",
        description: "Get an upper hand on your web content, augment efficiency, & develop a shared environment with our Python CMS solutions."
    },
    {
        service: "Python Migrations",
        description: "Our Python engineers strategically migrate legacy content into modern systems in a secured, error-free, & robust way."
    },
    {
        service: "Advanced Python Programming",
        description: "Our experts have extensive experience in using Python tech stack for tangible results to reach your business vision."
    },
    {
        service: "Python Integration & Optimization",
        description: "Leverage the full-scale potential of Python integration & optimization functionalities for your app development needs."
    },
    {
        service: "Customized Python Solutions",
        description: "Our Python developers delve into ideation, reinvention, & scale development as per your enterprise's unique IT demands."
    },
    {
        service: "Python eCommerce App",
        description: "With using modern Python tools & technologies, we have a proven track record of developing scalable & secured eCommerce sites."
    }
];

export const slidesData = [
    {
        title: "Rapid Development",
        content:
            "Python’s built-in tools & features allow for faster development, reducing time-to-market.",
        backgroundClass: "bg-1",
    },
    {
        title: "Scalability",
        content:
            "Python is designed to handle high-traffic & complex applications, making it perfect for growing businesses",
        backgroundClass: "bg-2",
    },
    {
        title: "Security",
        content:
            "With built-in protection against common security threats like SQL injection & cross-site scripting, Python ensures secure applications",
        backgroundClass: "bg-3",
    },
    {
        title: "Versatility",
        content:
            "From simple websites to complex web apps, Python is flexible enough to handle a variety of development needs",
        backgroundClass: "bg-4",
    },
    {
        title: "Maintainability",
        content:
            'Its clean architecture & "Don’t Repeat Yourself" (DRY) principle make Python applications easy to manage & scale over time.',
        backgroundClass: "bg-1",
    },
];

export const WhoWeServeData = [
    {
        icon: "/images/servie-icon/startups.svg",
        title: "Budget savings",
        description: "Assembling a local Python team is unavoidably expensive. By approaching Innowise. you bypass many hurdles & avoid redundantexpenses such as training fees. taxes. & software licenses.",
        link: "#",
        borderClass: "border-1",
    },
    {
        icon: "/images/servie-icon/company.png",
        title: "Software product companies",
        description: "When you hire ROR developers. you avoid the risks of budget overruns & missed deadlines. Innowise provides solid risk management plans & has an array of risk mitigation measures",
        link: "#",
        borderClass: "border-2",
    },
    {
        icon: "/images/servie-icon/industries.svg",
        title: "Enterprises from 30+ industries",
        description:
            "Innowise has experts with excellent development backgrounds. so you can rest assured that your project is in good hands. Pyrggyelgprneg",
        link: "#",
        borderClass: "border-3",
    },
];

export const hirePageDeliver = [
    {
        image: "/images/hire-page-images/card-1.avif",
        title: "Complex SaaS systems",
        description: "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc."
    },
    {
        image: "/images/hire-page-images/card-2.avif", // Assumed path based on provided example
        title: "Complex SaaS systems",
        description: "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc."
    },
    {
        image: "/images/hire-page-images/card-3.avif", // Assumed path based on provided example
        title: "Complex SaaS systems",
        description: "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc."
    },
];

export const companyCtaContentForPython = {
    heading: "Work with our Python developers in the USA at no Initial Cost.",
    subHeading: "Real code, real outcomes.",
    buttonText: "Schedule a Call"
}

// export const hirePythonEngagementModels = {
//     shortHeading: "Engagement Models",
//     heading: "Customized DevOps Solutions for Business Growth",
//     subheading: "Need DevOps expertise? Integrate us wherever you need us most. We tailor every engagement to fit your workflow, infrastructure, and delivery goals whether you’re scaling your operations team, automating deployments, or optimizing cloud infrastructure.",
//     models: [
//         {
//             icon: "/images/engagement-model-gifs/hourly-icon.svg",
//             index: 1,
//             iconWidth: 40,
//             title: "Flexible DevOps Expertise On-Demand",
//             description: "Need additional DevOps engineers for specific projects or ongoing support? Quickly scale your operations with pre-vetted DevOps experts skilled in CI/CD automation, container orchestration, and cloud infrastructure all without the delays or overhead of traditional recruitment processes.",
//         },
//         {
//             icon: "/images/engagement-model-gifs/price-icon.svg",
//             index: 2,
//             iconWidth: 35,
//             title: "Dedicated Teams",
//             description: "Need a full DevOps team to manage complex cloud or automation projects? We assemble dedicated teams focused solely on your business objectives, handling everything from infrastructure provisioning and pipeline setup to monitoring and system optimization.",
//         },
//     ],
//     cta: {
//         text: "Talent on Your Terms",
//         button: "Accelerate with Data Science",
//         link: "/contact-us",
//     },
// }

export const hirePythonFaqSection = {
    mainHeading: "Frequently Asked Questions about Python Development",
    faqData: [
        {
            id: "collapseOne",
            question: "How quickly can Python engineers start working on my project?",
            answer:
                "At Bitsclan IT Solutions, our Python engineers can usually be onboarded within 3–5 business days after finalizing the scope. We handle environment setup, repository access, and tool alignment (GitHub, Jira, Slack, etc.) to ensure your team begins execution without delay.",
        },
        {
            id: "collapseTwo",
            question: "What types of projects can your Python engineers handle?",
            answer:
                "Our developers have experience across multiple domains including web apps (Django, Flask), data analytics, automation scripts, APIs, and AI/ML integrations. Whether you need a scalable backend, microservices, or a full-stack application, we match engineers with the right expertise for your use case.",
        },
        {
            id: "collapseThree",
            question: "How do you ensure the quality and reliability of your Python developers?",
            answer:
                "Every Python engineer at Bitsclan IT Solutions passes a rigorous multi-stage evaluation, including live coding tests, architecture reviews, and problem-solving assessments. Only developers with proven production experience and strong understanding of clean code principles join your project.",
        },
        {
            id: "collapseFour",
            question: "Can your Python engineers work alongside our existing team?",
            answer:
                "Yes. Our engineers integrate directly into your team’s workflow using your tools, sprint cycles, and code review process. They collaborate through daily standups, pull requests, and shared repositories, ensuring transparency and smooth coordination.",
        },
        {
            id: "collapseFive",
            question: "What frameworks and tools do your Python engineers use?",
            answer:
                "Our team is skilled in leading frameworks and libraries such as Django, Flask, FastAPI, Pandas, NumPy, and Celery, along with DevOps tools like Docker, Kubernetes, and CI/CD pipelines. We select the stack that best aligns with your project’s scale, performance, and infrastructure.",
        },
        {
            id: "collapseSix",
            question: "How do you maintain code quality and security throughout the project?",
            answer:
                "We follow PEP 8 standards, enforce peer code reviews, and use automated testing frameworks for every build. For security, we apply secure coding guidelines, encrypted credentials, and access controls to keep your codebase protected from vulnerabilities.",
        },
        {
            id: "collapseSeven",
            question: "Can I scale my Python development team as the project grows?",
            answer:
                "Absolutely. Our engagement model allows you to scale up or down based on project demands. Whether you’re adding new developers for a major release or streamlining during maintenance, we adjust quickly without long-term contracts or overhead.",
        },
        {
            id: "collapseEight",
            question: "What if the assigned Python developer isn’t a good fit?",
            answer:
                "If a developer doesn’t meet expectations, we’ll replace them immediately at no additional cost. Our focus is on maintaining your project’s momentum, delivery quality, and team performance without any downtime.",
        },
        {
            id: "collapseNine",
            question: "How do you handle project handover and offboarding?",
            answer:
                "Before any transition, we ensure a complete knowledge transfer, including updated documentation, deployment guides, and environment credentials. All code and assets remain under your full ownership, ensuring business continuity and IP protection.",
        },
        {
            id: "collapseTen",
            question: "Do you provide post-development support and maintenance?",
            answer:
                "Yes. We offer post-deployment maintenance, including bug fixes, feature enhancements, and performance tuning. Optional retainer models are available for ongoing optimization, scaling, or version upgrades.",
        },
    ]
}


export const hirePythonTestimonialsData = [
    {
        name: "Ethan Carter",
        enterprise: "FinTech Platform Development",
        country: "New York, US",
        profileImage: "/images/testimonials/michael.avif",
        logoImage: "/images/logo-2.png",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "CTO at FinEdge Analytics",
        feedback:
            "Bitsclan’s Python developers helped us rebuild our backend architecture with Django and FastAPI, improving performance and scalability dramatically. Their clean coding practices and deep technical expertise exceeded our expectations.",
        serviceTags: ["FinTech", "Backend Development"],
    },
    {
        name: "Sarah Mitchell",
        enterprise: "Healthcare Automation",
        country: "Boston, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "Head of Operations at Medinova Health",
        profileImage: "/images/testimonials/sophie.avif",
        logoImage: "/images/logo-2.png",
        feedback:
            "The Python team automated several manual workflows and built secure data APIs that streamlined our patient data management. Their proactive approach saved us months in development time.",
        serviceTags: ["Healthcare", "Automation"],
    },
];

export const hirePythonBitsclanContent = [
    {
        id: "Tab1",
        label: "Top-Tier Python Talent",
        content:
            "We hire only the top 1% of Python developers skilled in Django, Flask, FastAPI, and AI/ML integrations. Each engineer is rigorously tested for problem-solving, scalability, and clean architecture design to ensure enterprise-grade quality in every line of code.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab2",
        label: "Timezone-Aligned Collaboration",
        content:
            "Our Python teams work in your timezone, ensuring real-time communication and agile collaboration. From sprint planning to code reviews, we keep your project aligned and on track without delays.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab3",
        label: "Effective Communication",
        content:
            "Our engineers communicate seamlessly with your in-house teams, bridging technical and business discussions with clarity. You’ll always know project status, challenges, and next steps — no guesswork involved.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab4",
        label: "Full-Stack Python Expertise",
        content:
            "From API-driven backends and AI pipelines to web automation and analytics platforms, our Python experts manage the full development lifecycle — ensuring performance, scalability, and long-term maintainability.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab5",
        label: "Scalable Team Structure",
        content:
            "Quickly expand your development capacity with pre-vetted Python engineers. Whether you need one specialist or a full team, we scale resources based on your evolving business needs.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab6",
        label: "Streamlined Contracts & Compliance",
        content:
            "We simplify engagement with globally accepted MSAs and SOWs. Our processes are transparent, legally compliant, and designed for enterprise-grade governance.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab7",
        label: "NDA & IP Protection",
        content:
            "Your ideas and codebase remain 100% protected. We enforce NDAs, IP agreements, and access controls to ensure your proprietary assets are fully secure throughout the project lifecycle.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab8",
        label: "Enterprise-Level Security",
        content:
            "All Python development adheres to best practices and global security standards like ISO 27001 and SOC 2. We implement encrypted communication, secure authentication, and continuous compliance monitoring.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
    {
        id: "Tab9",
        label: "Managed Project Delivery",
        content:
            "Every project is led by a dedicated delivery manager ensuring on-time execution, code quality, and performance metrics. We handle planning, reporting, and optimization so you can focus on outcomes, not oversight.",
        btnText: "Contact Our Experts",
        btnLink: "/contact-us",
    },
];

export const ctaSection = {
    mainHeading: "Need Skilled Python Developers?",
    description:
        "Hire expert Python engineers for scalable apps, automation, AI/ML, and backend systems.",
    btnText: "Hire a Python Developer",
    btnLink: "/contact-us",
};

export const hirePythonEngagementModels = {
    shortHeading: "Engagement Models",
    heading: "Flexible Python Development Engagement Models",
    subheading:
        "Partner with us the way that fits your business best. Whether you need expert Python developers for a short-term project or a dedicated team for continuous development, we offer flexible engagement options that align with your goals, timeline, and budget.",
    models: [
        {
            icon: "/images/engagement-model-gifs/hourly-icon.svg",
            index: 1,
            iconWidth: 40,
            title: "On-Demand Python Developers",
            description:
                "Access pre-vetted Python developers on an hourly or project basis. Ideal for startups or enterprises needing quick scalability and specialized expertise without long-term commitments.",
        },
        {
            icon: "/images/engagement-model-gifs/price-icon.svg",
            index: 2,
            iconWidth: 35,
            title: "Dedicated Python Teams",
            description:
                "Build a dedicated team of Python engineers focused solely on your business objectives. Perfect for ongoing projects requiring deep technical ownership, agile development, and long-term collaboration.",
        },
    ],
    cta: {
        text: "Talent on Your Terms",
        button: "Hire Python Developers",
        link: "/contact-us",
    },
};

export const hirePythonChallengesData = [
    {
        title: "Finding Skilled Data Science Talent",
        description:
            "The demand for experienced data scientists far exceeds supply. Many candidates possess academic knowledge, but lack the hands on experience required to build, deploy, and maintain real-world data systems that provide actionable business insights.",
    },
    {
        title: "Lengthy Onboarding & Evaluation Process",
        description:
            "Screening data science candidates is a complex and time consuming process. Evaluating their expertise in data modeling, coding proficiency, and statistical analysis can take months, delaying data driven initiatives and innovation cycles.",
    },
    {
        title: "Cost Overruns & Inefficient Data Infrastructure",
        description:
            "Inefficient data processing cycles, unoptimized compute resources, and a lack of automation often lead to escalating cloud costs especially when large datasets or retraining models are involved. These inefficiencies affect both project budgets and timelines.",
    },
    {
        title: "Communication Gaps Between Teams",
        description:
            "Bridging the gap between technical data scientists and non-technical stakeholders can be challenging. Misalignment in objectives or performance metrics often leads to delays, rework, and a reduced ROI from data science initiatives.",
    },
    {
        title: "Securing Elite, Production-Ready Python Expertise",
        description:
            "The global scarcity of Python engineers proficient in building **scalable, enterprise-grade applications**—spanning from high-performance data pipelines (PySpark, Dask) to robust MLOps and microservices (FastAPI, Django)—creates a critical bottleneck, escalating hiring costs and stalling key innovation projects.",
    },
]

export const hirePythonDeveloperSolution = [
    {
        title: "Access to Vetted Python Architects & Engineers",
        description:
            "We provide immediate access to a pipeline of rigorously tested Python experts, from **Senior Backend Engineers** to **MLOps Specialists**. Each candidate is vetted for mastery in frameworks (Django, FastAPI), clean code standards, and the ability to build scalable, production-ready systems that deliver tangible business results.",
    },
    {
        title: "Accelerated Time-to-Market (T.T.M)",
        description:
            "Our developers integrate seamlessly within 48 hours, eliminating the typical 3-6 month hiring and onboarding cycle. Leverage Python's rapid development capabilities to prototype, build, and deploy new applications, features, and internal tools, dramatically **accelerating your innovation cycles and product launch timeline**.",
    },
    {
        title: "Robust MLOps & Data Pipeline Automation",
        description:
            "Secure Python experts who specialize in end-to-end automation. They implement CI/CD for data processing and model deployment, significantly reducing manual effort and ensuring your data pipelines (PySpark, Dask) and machine learning models are **always stable, efficient, and audit-ready in production**.",
    },
    {
        title: "Enterprise-Grade Scalability & Cost Optimization",
        description:
            "Hire Python talent focused on optimization. They architect microservices and cloud-native solutions (AWS, GCP, Azure) to handle massive user loads efficiently. This expertise directly translates into **up to 40% savings in cloud compute costs** while guaranteeing system performance under peak demand.",
    },
    {
        title: "Simplified Codebase & Long-Term Maintainability",
        description:
            "Python's inherent readability, combined with our developers' commitment to software engineering best practices, results in a clean, well-documented, and modular codebase. This dramatically **lowers long-term maintenance costs**, reduces technical debt, and allows your team to iterate faster.",
    },
    {
        title: "Driving AI/ML & Data Science ROI",
        description:
            "Tap into the core strength of Python: its Data Science ecosystem. Our engineers integrate specialized libraries (TensorFlow, PyTorch, Pandas) to build and deploy advanced analytical models, turning raw data into **predictive insights, automated workflows, and measurable revenue growth**.",
    },
];